var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`field-${_vm.field}`]})
}
var staticRenderFns = []

export { render, staticRenderFns }